import { render, staticRenderFns } from "./CODataTable.vue?vue&type=template&id=2942fe99&scoped=true&"
import script from "./CODataTable.vue?vue&type=script&lang=js&"
export * from "./CODataTable.vue?vue&type=script&lang=js&"
import style0 from "./CODataTable.vue?vue&type=style&index=0&id=2942fe99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2942fe99",
  null
  
)

export default component.exports